import { render, staticRenderFns } from "./DeleteTableItemDialog.vue?vue&type=template&id=39dbc852&scoped=true"
import script from "./DeleteTableItemDialog.vue?vue&type=script&lang=js"
export * from "./DeleteTableItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dbc852",
  null
  
)

export default component.exports